import React, { useState } from 'react';
import { Grid } from '@alifd/next';
import CommonHeader from '@/components/CommonHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import LeftList from './component/leftList';
import RightCard from './component/rightCard';
import $i18n from '@/i18n';

import './index.less';
const { Row, Col } = Grid;

const breadcrumbConfig = [
  {
    key: 'miniAppStore',
    breadcrumbName: $i18n.get({
      id: 'aopf.pages.channel.channelList.header.title',
      dm: '小程序商店',
    }),
    path: `/miniAppStore`,
  },
  {
    key: 'setting',
    breadcrumbName: $i18n.get({
      id: 'aopf.pages.miniAppStore.tabMiniAppOperate',
      dm: '应用市场小程序运营',
    }),
  },
];

const MiniAppOperate: React.FC = () => {
  const { spaceId } = getQueryStringArgs();

  const [checkItem, setCheckItem] = useState(0);

  return (
    <div className="settingContainer">
      <CommonHeader
        title={$i18n.get({
          id: 'aopf.pages.miniAppStore.operate.setting.operational.settings',
          dm: '运营设置',
        })}
        backTo={`/miniAppStore?spaceId=${spaceId || ''}`}
        breadcrumbs={breadcrumbConfig}
      />
      <div className="content">
        <Row gutter={12}>
          <Col span="6">
            <LeftList checkItem={checkItem} setCheckItem={setCheckItem} />
          </Col>
          <Col span="18">
            <RightCard checkItem={checkItem}/>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MiniAppOperate;
